import React, { memo, useCallback, useMemo,useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import { ReactComponent as FirstLegendIcon } from "../../assets/icons/gaugeChart1.svg";
import { ReactComponent as SecondLegendIcon } from "../../assets/icons/gaugeChart2.svg";
import { title } from 'process';
import { isMobileView } from '../../utils/Reusables';


const  HalfGaugeChart = (props) => {
    let { resultSet, COLORS_SERIES, isLegendVisible, dateFieldFormat, handleCategoryData, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings, timeDimensionDateFormat } = props;
    const [chartHeight, setChartHeight] = React.useState(320);
    const [resData, setResData] = useState(resultSet.rawData())
    const [sereisData, setSeriesData] = useState(resultSet.series(pivotConfig))    
    

    const gaugeObj = useMemo(() => {
        //console.log(resData,sereisData,columnTitle,title,finalTitle)
        let largerValue = resData[0][sereisData[0].key]
        let smallerValue = sereisData.length > 1 ? resData[0][sereisData[1].key] : 0
        let title = sereisData[0]?.key?.split('.')?.[1]
        let finalTitle = sereisData.length > 1 ? sereisData[1]?.key?.split('.')?.[1] : ''
        if (Object.keys(columnTitle[0]).length) {
            for (let key in columnTitle[0]) {
                if (key.split('.')?.[1] === title) {
                   var newTital = columnTitle[0][key]
                }
                else if (key.split('.')?.[1] === finalTitle) {
                  var  newFinalTitle = columnTitle[0][key]
                }
            }
        }
        return {
            total: largerValue,
            firstValue: smallerValue,
            secondValue: largerValue - smallerValue,
            firstTitle: newFinalTitle ?? finalTitle,
            secondTitle: newTital ?? title,
            gauzecolor:parseFloat(smallerValue) / parseFloat(largerValue)
        }
    },[resData])

    const series = resultSet.series(pivotConfig).map((s, index) => ({
        type: 'gauge',
        radius: '100%',
        startAngle: 180,
        endAngle: 0,
        clockwise: true,
        splitNumber: 5,
        min: 0,
        max: parseFloat(gaugeObj.total),
        center: ['50%', '55%'],
        axisLine: {
            show: true,
            lineStyle: {
                width: 50,
                shadowBlur: 0,
                color: [
                    [gaugeObj.gauzecolor, '#80CC8C'],
                    [1, '#E46179']
                ],
            },
        },
        axisTick: {
            show: false,
            splitNumber: 5,
            length: 10,
            lineStyle: {
                color: 'auto',
            },
        },
        splitLine: {
            show: false,
            length: 15,
            lineStyle: {
                color: 'auto',
            },
        },
        axisLabel: {
            show: false,
            distance: 5,
            textStyle: {
                color: 'auto',
                fontSize: 10,
            },
        },
        pointer: {
            show: true,
            length: '70%',
            offsetCenter: [0, '-50%'],
            width: 2,
            itemStyle: {
                color: '#202124', // Color of the main line
            },
        },
        title: {
            show: false,
            offsetCenter: ['-65%', '-80%'],
            textStyle: {
                color: '#202124',
                fontSize: 12,
            },
        },
        detail: {
            show: false,
            offsetCenter: ['-65%', '-55%'],
            textStyle: {
                color: 'auto',
                fontSize: 14,
            },
        },
        data: [
            {
                value: parseFloat(gaugeObj.firstValue),
                name: gaugeObj.firstTitle,
            },

        ],

    }));

    const options = {
        series: series
    };

    const renderLegend = useCallback(() => {
        return (
            <div style={{float:'right'}}>
                {(
                     resultSet?.loadResponse?.pivotQuery?.measures.length > 1  ?
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'left', marginBottom: '5px' }}>
                            <SecondLegendIcon style={{ marginRight: '10px' }} />
                            <p style={{ margin: '0', fontSize: '14px', lineHeight: '19px' }}>{gaugeObj.secondTitle} : <span style={{fontWeight: '600'}}>{gaugeObj.secondValue}</span></p>
                        </div>
                        :
                        null
                )}

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'left' }}>
                    <FirstLegendIcon style={{ marginRight: '10px' }} />
                    <p style={{ margin: '0', fontSize: '14px', lineHeight: '19px' }}>{gaugeObj.firstTitle} : <span style={{fontWeight: '600'}}>{gaugeObj.firstValue}</span></p>
                </div>
            </div>
        )
    },[gaugeObj])


    const renderLegendBottom = useCallback(() => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginTop: '25px'}}>
                {(
                     resultSet?.loadResponse?.pivotQuery?.measures.length > 1  ?
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'left', marginBottom: '5px' }}>
                            <SecondLegendIcon style={{ marginRight: '10px' }} />
                            <p style={{ margin: '0', fontSize: '14px', lineHeight: '19px' }}>{gaugeObj.secondTitle} : <span style={{ fontWeight: '600'}} >{gaugeObj.secondValue}</span></p>
                        </div>
                        :
                        null
                )}

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'left' }}>
                    <FirstLegendIcon style={{ marginRight: '10px' }} />
                    <p style={{ margin: '0', fontSize: '14px', lineHeight: '19px' }}>{gaugeObj.firstTitle} : <span style={{ fontWeight: '600'}} >{gaugeObj.firstValue}</span></p>
                </div>
            </div>
        )
    },[gaugeObj])    
    //console.log(options)

    return (
        <div data-data="gauage-chart" style={{overflow: 'hidden'}}>
            {(isLegendVisible && (legendPosition === 'top' && !isMobileView()) ? renderLegend() : null)}


            <ReactEcharts
                style={{
                    height: chartHeight + 'px',
                    width: '100%',
                }}
                option={options}
                opts={{ renderer: 'svg' }}
            />

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', 
                marginTop: isMobileView() ? '-200px' : '-160px' 
            }}>
                <span><h4 style={{fontSize: '14px', lineHeight: '19px', fontWeight: '600'}}>Total</h4></span>
                <span style={{ fontWeight: 'bold', fontSize: '34px', lineHeight: '46px', fontWeight: '600' }}><h3>{gaugeObj.total}</h3></span>
                <span><h4 style={{fontSize: '14px', lineHeight: '19px', fontWeight: '600', marginTop: '4px'}} >{''}</h4></span>
            </div>

            {(isLegendVisible && (legendPosition === 'bottom' || isMobileView()) ? renderLegendBottom() : null)}


        </div>
    )

};

export default memo(HalfGaugeChart)
